module.exports = __webpack_public_path__ + "img/5diamante.24fd440c.png";